import React from 'react';
import { Loader2 } from 'lucide-react';

export function PageLoader({ label = 'Loading…' }) {
  return (
    <div className="flex items-center justify-center py-16 text-muted-foreground">
      <Loader2 size={16} className="animate-spin mr-2" /> {label}
    </div>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div className="text-center py-14 border border-dashed border-border rounded-xl bg-secondary/30">
      <div className="text-sm font-medium">{title}</div>
      {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6" data-testid={testId}>
      <div>
        <h1 className="text-2xl font-semibold tracking-tight" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
